import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useCallback } from "react";
import { classes } from "../../utils/classes";
import { AmbassadorsProvider } from "../../hooks/useAmbassadors";
import useHiddenCursor from "./hooks/useHiddenCursor";
import useSettings from "./hooks/useSettings";
import useSleeping from "./hooks/useSleeping";
import Overlay from "./components/overlay/Overlay";
// Hide the overlay after 5s of inactivity
var timeout = 5000;
export default function App() {
    // Show/hide the overlay based on mouse movement
    var settings = useSettings();
    var _a = useSleeping(), sleeping = _a.sleeping, wake = _a.wake, sleep = _a.sleep, addSleepListener = _a.on, removeSleepListener = _a.off;
    // When the user interacts, show the overlay
    var interacted = useCallback(function () { return wake(timeout); }, [wake]);
    // Hide the cursor when the user is idle
    var _b = useHiddenCursor(), showCursor = _b[1];
    // When the overlay is awoken, show the cursor
    useEffect(function () {
        addSleepListener("wake", showCursor);
        return function () { return removeSleepListener("wake", showCursor); };
    }, [addSleepListener, removeSleepListener, showCursor]);
    return (_jsx(AmbassadorsProvider, { children: _jsx("div", { className: classes("relative mx-4 h-full w-full transition-opacity", sleeping &&
                !(process.env.NODE_ENV === "development" &&
                    settings.disableOverlayHiding.value)
                ? "opacity-0 [&_*]:pointer-events-none"
                : "opacity-100"), onMouseEnter: interacted, onMouseMove: interacted, onWheel: interacted, onTouchMove: interacted, onKeyDown: interacted, onMouseLeave: sleep, children: _jsx(Overlay, {}) }) }));
}
